import { CommonHelper } from "../helpers";
import { mapGetters } from "vuex";
import LoanProjection from "../models/loanProjection";
import { LoanFormElement, projectionType } from "../helpers/constant";
import ICEAdvanceLoanType from "../models/iceloanAdvanceType";

import {
  GET_Liablity_ENTITY_INFORMATION,
  SET_ICE_PROJECTION_MODEL,
} from "../helpers/vuex-constants";
import { mapActions } from "vuex";
import BaseIceIntegration from "./ice-integration";
export default {
  mixins: [BaseIceIntegration],
  computed: {
    ...mapGetters("loan", {
      ClientsInfo: GET_Liablity_ENTITY_INFORMATION,
    }),
  },
  methods: {
    ...mapActions("loan", {
      setIceProjectionModel: SET_ICE_PROJECTION_MODEL,
    }),
    prepareAPIModel(baselineData) {
      let baselineDataArray = [];
      baselineDataArray.push(baselineData);
      return this.prepareAPIModelArray(baselineDataArray);
    },
    prepareAPIModelArray(baselineData) {
      let inputClientData = this.prepareBaseAPIModel();
      inputClientData.ProjectionInfo = this.fillAllClientInfo(baselineData);
      return inputClientData;
    },
    async getLoanProjection(inputData, fileName) {
      const iceApiResponse = await this.getProjection(inputData, fileName);
      if (iceApiResponse.iceInput) {
        this.setIceProjectionModel(iceApiResponse);
        return LoanProjection.setLoanProjections(iceApiResponse);
      } else {
        return [];
      }
    },
    fillAllClientInfo(baselineData) {
      let LoanInfo = [];
      for (let i = 0; i < baselineData.length; i++) {
        LoanInfo.push(this.fillBasicLoanInfo(baselineData[i]));
      }
      return LoanInfo;
    },
    fillBasicLoanInfo(formModel) {
      let ClientLoan = {};
      ClientLoan.UniqueId = formModel.uniqueId;
      ClientLoan.EntityType = formModel.entityType;
      ClientLoan.TypeId = formModel.loanType;
      ClientLoan.ProjectionType = projectionType.loan;
      ClientLoan.Projections = this.fillBasicProjectionInfo(
        formModel,
        LoanFormElement
      );
      ClientLoan.Projections = ClientLoan.Projections.concat(
        this.fillAdvanceDetails(formModel.advancedetails, formModel.description)
      );
      return ClientLoan;
    },
    fillAdvanceDetails(advanceDetailsOption, loanadescription) {
      let advanceLoanInfo = [];
      advanceLoanInfo = ICEAdvanceLoanType.setLoanAdvanceType(
        advanceDetailsOption,
        loanadescription
      );
      return advanceLoanInfo;
    },

    setLoanModel(projectionData, baselineData) {
      let reponseData = {
        totalLoanRepayment: CommonHelper.convertAmountIntoCurrency(
          projectionData.loanProjectionResult[0].totalLoanRepayment
        ),
        totalInterest: CommonHelper.convertAmountIntoCurrency(
          projectionData.loanProjectionResult[0].totalInterest
        ),
        LoanPaindId: projectionData.loanProjectionResult[0].LoanPaindId,
        barchartData: LoanProjection.setBarChartProjections(
          projectionData.loanProjectionResult[0].loanProjection
        ),
        areaChartData: LoanProjection.setAreaChartProjections(
          projectionData.loanProjectionResult[0].loanProjection,
          baselineData
        ),
      };
      return reponseData;
    },
  },
};
